// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2H0um","inner":"Footer_inner__-AWD-","nextIcon":"Footer_nextIcon__23bmP","innerLeft":"Footer_innerLeft__2GNhY"};